import React from 'react'

import Button from '@react/react-spectrum/Button'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import Wait from '@react/react-spectrum/Wait'
import { getIntegrationDetails, getTenantId } from '@demo-system/commons/utilities/integrations'

import { ImsOrgDialog } from './ImsOrgDialog'
import { DataCollectionTile, AepTile, TargetTile } from './tiles'

import { useMyEnvironments, useLaunchDetails } from 'hooks'

export function ImsOrgSection({ integrations, channel, projectName, projectType, disabled, onChange }) {
  const { aep, imsOrg, launch } = integrations
  const { loading: loadingEnvironments, data: environments } = useMyEnvironments()
  const { sandboxName, orgId, orgName } = getIntegrationDetails(integrations)

  const {
    loading: loadingDetails,
    error,
    launchDetails,
  } = useLaunchDetails({
    propertyId: launch?.propertyID || launch?.propertyId,
    appId: launch?.appID || launch?.appId,
    imsOrgID: orgId,
  })

  const tenantId = getTenantId({ integrations })

  const loading = loadingEnvironments || loadingDetails

  const isSet = !!imsOrg

  const { propertyName, propertyID, company, solutions } = launchDetails || {}
  const launchUrl = launch?.launchUrl
    ? launch?.launchUrl
    : tenantId &&
      sandboxName &&
      company &&
      propertyID &&
      `https://experience.adobe.com/#/@${tenantId}/sname:${sandboxName}/data-collection/tags/companies/${company}/properties/${propertyID}`
  const target = solutions?.target

  const launchText = propertyName || launch?.propertyName || launch?.propertyId || launch?.addId

  const dialogProps = { environments, channel, projectName, projectType, imsOrg, aep, launch, onChange }

  if (!isSet) {
    return (
      <div className='ImsOrgSection'>
        <div className='ImsOrgSection__header'>
          <h4>IMS Organization</h4>
        </div>
        <div className='ImsOrgSection__emptyState'>
          <ModalTrigger>
            <Button variant='cta' quiet disabled={disabled || loading}>
              Select environment{' '}
              {loading && (
                <>
                  &nbsp;&nbsp;
                  <Wait size='S' />
                </>
              )}
            </Button>
            <ImsOrgDialog {...dialogProps} />
          </ModalTrigger>
        </div>
      </div>
    )
  }

  return (
    <div className='ImsOrgSection'>
      <div className='ImsOrgSection__header'>
        <h4>{orgName || orgId}</h4>
        <ModalTrigger>
          <Button variant='action' quiet disabled={disabled || loading}>
            {loading ? <Wait /> : 'Edit'}
          </Button>
          <ImsOrgDialog {...dialogProps} />
        </ModalTrigger>
      </div>
      <DataCollectionTile text={launchText} error={error} url={launchUrl} loading={loadingDetails} />
      <AepTile aep={launch && aep} />
      <TargetTile target={launch && target} tenantId={tenantId} />
    </div>
  )
}
